export const sourceTypeMap = {
    0: 955740,
    1: 955740,
    2: 955740,
    3: 955740,
    4: 955740,
    5: 952310,
    6: 954210,
    7: 700025,
}
export function analysisSourceType (id) {
    // 使用正则表达式匹配 _ 和 _ 之间的内容
    const match = id.match(/_(\d+)_/);
    if (match && match[1]) {
        return sourceTypeMap[match[1]];
    }
    return null; // 如果没有匹配到，返回 null   
}